import { Parser } from 'expr-eval'

export const JMathEval = Parser.evaluate
